<script>
import EventManagementMixin from '../event/EventManagementMixin.vue';
import GfAnalyticsMixin from '../inc/GfAnalyticsMixin.vue';

const $ = require('jquery');
export default {
  mixins: [EventManagementMixin, GfAnalyticsMixin],

  methods: {
    stage(eventCampaignId, eventName, eventImagePath, eventUrl) { 
      
      this.$store.commit('change_event', {
        EventCampaignId : eventCampaignId, 
        EventName: eventName, 
        EventImagePath: eventImagePath, 
        EventUrl: eventUrl,
        Router_Name: this.$route.name
      });
      
      if(this.$store.state.selected_charity != '' && this.$store.state.selected_event != '') {
        this.$router.push({name: 'complete_individual' });
      }else{
        this.$router.push({name: 'charity_individual' });
      }

      this.analytics({
        'event': 'create_page',
        'createType': 'individual', 
        'stepNumber': '3 of 4',
        'stepName': 'select event',
        'causeName': this.$store.state.selected_charity.BeneficiaryName,
        'eventName': eventName
      });
    }
  }
}
</script>
